module.exports = __webpack_public_path__ + "static/media/men.5c90113f.png";